<ng-container [ngSwitch]="currentMethod">
	<ng-container *ngSwitchCase="IdentityVerificationMethod.IDVerse">
		<ifc-id-verse-content [advisorData]="advisorData" [loanId]="loanId" [config]="idVerseConfig" (verified)="onVerified($event)" (failedNoRetry)="onIdVerseFailedNoRetry($event)"></ifc-id-verse-content>
	</ng-container>
	<ng-container *ngSwitchCase="IdentityVerificationMethod.KBA">
		<ifp-kba-form-content></ifp-kba-form-content>
	</ng-container>
</ng-container>